
/* injects from baggage-loader */

'use strict';

import { trophies } from '../index.const';

import { findIndex } from 'lodash';

export default class StageBaseController {
    constructor($log, $rootScope, $state, $timeout, Dialog, Trophies, Session, route) {
        'ngInject';
        this.$log = $log;
        this.Dialog = Dialog;
        this.Trophies = Trophies;
        this.Session = Session;
        this.$rootScope = $rootScope;
        this.$state = $state;
        this.$timeout = $timeout;

        this.route = route;

        this.lifes = 3;

        this.model = {
            items: []
        };  

        this.acertos = [];

    }

    $onInit(){
        //descomentar isso aqui pra voltar a proteção de level
        //if(this.defaultLevel > this.$rootScope.$currentUser.level){
        //    return this.$state.go('main');
        //}

        //se não for chef, mostra o mapa da região
        this.state.region !== 'chef' ? this.Dialog.showRegionModal(this.state.region) : false;
        // Bind events
        this.$rootScope.$on('finish:countdown', this.onFinishCountdown.bind(this));
    }

    $onDestroy(){
        this.$rootScope.$emit('reset:stage');
    }

    toNextBalloon(){
        this.balloons.step++;

        if(this.balloons.steps.length === this.balloons.step){
            this.$rootScope.$emit('start:countdown');
        }
    }

    // Player

    toLevel(level){ 
        let updates = this.Session.get();
        updates.user.level = level;
        this.Session.save(updates);
        // update views
        this.$rootScope.$currentUser.level = level;
    }

    toType(type){
        let updates = this.Session.get();
        updates.user.type = type;
        this.Session.save(updates);
        // update views
        this.$rootScope.$currentUser.type = type;
    }

    dropLife(){
        this.lifes--;
        if(this.lifes <= 0){
            this.forceFinishStage();
        }
    }

    // Dialogs
    
    openSuccess(text){
        if(this.defaultLevel !== this.$rootScope.$currentUser.level){
            return this.$state.go('main');
        }

        if(this.defaultLevel < 6){
            this.toLevel(( this.defaultLevel + 1 ));
        }
        this.completeStage();
        
        let msg = text || 'Muito bem! Você pediu uma entrada, um <br> prato principal, uma sobremesa e uma <br> bebida. O seu pedido foi confirmado!';
        let type = 'ok';

        this.Dialog.showFeedback(msg, type, () =>{
            let indexOf = this.Trophies.collectThrophies('default');
            let trophy = trophies.default[indexOf];
            this.Dialog
                .showTrophy(trophy, this.onDefaultTrophyClose.bind(this))
        });
    }

    onDefaultTrophyClose(){
        let indexOf = this.Trophies.collectThrophies('chef');
        let trophy = trophies.chef[indexOf];

        this.$timeout(() => {
            this.Dialog.showTrophy(trophy, () => this.$state.go(this.nextRoute));
        }, 600);

    }

    openFail(text){
        let msg = text || 'Não foi possível confirmar o seu pedido. <br> Algum prato não foi solicitado na ordem <br> correta.';
        let type = 'fail';
        
        this.Dialog.showFeedback(msg, type, () =>{
            this.$rootScope.$emit('reset:stage');
            this.dropLife();
        }, () => {
            this.$rootScope.$emit('reset:stage');
            this.dropLife();
        });
                
    }

    onFinishCountdown(){
        let msg = 'Não foi possível confirmar o seu pedido. <br> Algum prato não foi solicitado na ordem <br> correta.';
        let type = 'fail';
        
        this.Dialog.showFeedback(msg, type, () =>{
            this.$rootScope.$emit('reset:stage');
            this.dropLife();
        }, () => {
            this.$rootScope.$emit('reset:stage');
            this.dropLife();
        });

    }
    
    forceFinishStage(){
        let msg = 'Todas suas chances foram esgotadas.';
        let type = 'fail';
        
        this.Dialog.showFeedback(msg, type, () =>{
            this.$state.go('main');
        }, () => {
            this.$state.go('main');
        });        
    }
    // Sessions methods
    completeStage(){
        let updates = this.Session.get();
        
        let stageIndexOf = findIndex(updates.stages, { 'route': this.route });
        
        updates.stages[stageIndexOf].completed = true;
        

        this.Session.save(updates);

    }
}


// WEBPACK FOOTER //
// ./src/app/pages/stage-base.controller.js